/**
 * Deriva el `roleId` (slug snake_case) de un nombre legible que escribe el usuario.
 * El ID es la llave del rol (fijo de por vida); el `displayName` es el texto libre.
 *
 * Reglas (alineadas con el regex que valida el backend `^[a-z][a-z0-9_]{2,49}$`):
 *  - quita acentos (NFD + strip diacríticos): "Atención" → "atencion", "Diseño" → "diseno"
 *  - a minúsculas
 *  - todo lo no [a-z0-9] → "_", colapsa "__", quita "_" de los bordes
 *  - asegura que empiece con letra (descarta dígitos/símbolos iniciales)
 *  - recorta a 50 chars
 *
 * Ej: "Supervisor de Cobranza" → "supervisor_de_cobranza".
 * Devuelve "" si no queda nada usable (ej. solo símbolos) → el caller valida contra el regex.
 */
export function slugifyRole(text: string): string {
    return text
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/_+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/^[^a-z]+/, '')
        .slice(0, 50)
        .replace(/_+$/, ''); // el slice(50) puede dejar un "_" colgado → lo limpiamos
}

/** Mismo regex que valida el backend (RoleManager) — un slug válido es un roleId aceptable. */
export const ROLE_SLUG_REGEX = /^[a-z][a-z0-9_]{2,49}$/;

/** True si el nombre legible produce un slug válido para usar como roleId. */
export function isValidRoleSlug(displayName: string): boolean {
    return ROLE_SLUG_REGEX.test(slugifyRole(displayName));
}
